__turbopack_context__.v({
  "chip": "lvmJTq_chip",
  "dot": "lvmJTq_dot",
  "link": "lvmJTq_link",
});
